import moment from "moment";

// action types
export const UPDATE_DATA_INICIO = "updateFgDataInicio";
export const UPDATE_DATA_FIM = "updateFgDataFim";
export const UPDATE_EMPRESA = "updateFgEmpresa";
export const UPDATE_PROJETO = "updateFgProjeto";
export const UPDATE_PLANO_FINANCEIRO = "updateFgPlanoFinanceiro";
export const UPDATE_CENTRO_DE_RESPONSABILIDADE = "updateFgCentroDeResponsabilidade";
export const UPDATE_PORTADOR = "updateFgPortador";
export const UPDATE_MODO_PR = "updateFgModoPR";
export const UPDATE_LOADING = "updateFgLoading";
export const UPDATE_LOADING_6MESES = "updateFgLoading6Meses";
export const UPDATE_PERM_MASTER = "updateFgMaster";
export const UPDATE_PERM_SECURITY = "updateFgSecurity";
export const UPDATE_PERM_CONFIGURACOES = "updateFgConfiguracoes";
export const UPDATE_PERM_DASHBOARD_PAGAR = "updateFgDashboardPagar";
export const UPDATE_PERM_DASHBOARD_RECEBER = "updateFgDashboardReceber";
export const UPDATE_FILTRO_ABAS = "updatefgFiltroAbas";
export const UPDATE_DATA_FILTRO_TIPO = "updatefgDataFiltroTipo";
export const UPDATE_EMITENTE = "updatefgEmitente";
export const UPDATE_EMITENTE_DESCRICAO = "updatefgEmitenteDescricao";
export const UPDATE_ORDENACAO_FILTRO_TIPO = "updatefgOrdenacaoFiltroTipo";

// mutation types
export const SET_DATA_INICIO = "setFgDataInicio";
export const SET_DATA_FIM = "setFgDataFim";
export const SET_EMPRESA = "setFgEmpresa";
export const SET_PROJETO = "setFgProjeto";
export const SET_PLANO_FINANCEIRO = "setFgPlanoFinanceiro";
export const SET_CENTRO_DE_RESPONSABILIDADE = "setFgCentroDeResponsabilidade";
export const SET_PORTADOR = "setFgPortador";
export const SET_MODO_PR = "setFgModoPR";
export const SET_LOADING = "setFgLoading";
export const SET_LOADING_6MESES = "setFgLoading6Meses";
export const SET_PERM_MASTER = "setFgMaster";
export const SET_PERM_SECURITY = "setFgSecurity";
export const SET_PERM_CONFIGURACOES = "setFgConfiguracoes";
export const SET_PERM_DASHBOARD_PAGAR = "setFgDashboardPagar";
export const SET_PERM_DASHBOARD_RECEBER = "setFgDashboardReceber";
export const SET_FILTRO_ABAS = "setfgFiltroAbas";
export const SET_DATA_FILTRO_TIPO = "setfgDataFiltroTipo";
export const SET_EMITENTE = "setfgEmitente";
export const SET_EMITENTE_DESCRICAO = "setfgEmitenteDescricao";
export const SET_ORDENACAO_FILTRO_TIPO = "setfgOrdenacaoFiltroTipo";

const state = {
    fgDataInicio: window.localStorage.getItem("validadeFiltroData") ==
        moment().format("YYYY-MM-DD") && window.localStorage.getItem("dataInicio") ?
        window.localStorage.getItem("dataInicio") : moment()
        .subtract(7, "days")
        .format("YYYY-MM-DD"),
    fgDataFim: window.localStorage.getItem("validadeFiltroData") ==
        moment().format("YYYY-MM-DD") && window.localStorage.getItem("dataFim") ?
        window.localStorage.getItem("dataFim") : moment().format("YYYY-MM-DD"),
    fgEmpresa: window.localStorage.getItem("validadeFiltroEmpresa") ==
        moment().format("YYYY-MM-DD") && window.localStorage.getItem("empresa") ?
        window.localStorage.getItem("empresa") : "0",
    fgProjeto: "0",
    fgPlanoFinanceiro: "0",
    fgCentroDeResponsabilidade: "0",
    fgPortador: "0",
    fgModoPR: window.localStorage.getItem("validadeFiltroModoPR") ==
        moment().format("YYYY-MM-DD") && window.localStorage.getItem("modoPR") ?
        window.localStorage.getItem("modoPR") : "R",
    fgLoading: false,
    fgLoading6meses: false,
    fgMaster: false,
    fgSecurity: false,
    fgConfiguracoes: false,
    fgDashboardPagar: false,
    fgDashboardReceber: false,
    fgFiltroAbas: 0,
    fgDataFiltroTipo: window.localStorage.getItem("validadeDataFiltroTipo") ==
        moment().format("YYYY-MM-DD") && window.localStorage.getItem("dataFiltroTipo") ?
        window.localStorage.getItem("dataFiltroTipo") : "vencimento",
    fgEmitente: window.localStorage.getItem("validadeEmitente") ==
        moment().format("YYYY-MM-DD") && window.localStorage.getItem("emitente") ?
        window.localStorage.getItem("emitente") : "",
    fgEmitenteDescricao: window.localStorage.getItem("validadeEmitenteDescricao") ==
        moment().format("YYYY-MM-DD") && window.localStorage.getItem("emitenteDescricao") ?
        window.localStorage.getItem("emitenteDescricao") : "",
    fgOrdenacaoFiltroTipo: window.localStorage.getItem("validadeOrdenacaoFiltroTipo") ==
        moment().format("YYYY-MM-DD") && window.localStorage.getItem("ordenacaoFiltroTipo") ?
        window.localStorage.getItem("ordenacaoFiltroTipo") : "vencimento"
};

const getters = {
    fgDataInicio(state) {
        return state.fgDataInicio;
    },
    fgDataFim(state) {
        return state.fgDataFim;
    },
    fgEmpresa(state) {
        return state.fgEmpresa;
    },
    fgProjeto(state) {
        return state.fgProjeto;
    },
    fgPlanoFinanceiro(state) {
        return state.fgPlanoFinanceiro;
    },
    fgCentroDeResponsabilidade(state) {
        return state.fgCentroDeResponsabilidade;
    },
    fgPortador(state) {
        return state.fgPortador;
    },
    fgModoPR(state) {
        return state.fgModoPR;
    },
    fgLoading(state) {
        return state.fgLoading;
    },
    fgLoading6meses(state) {
        return state.fgLoading6meses;
    },
    fgMaster(state) {
        return state.fgMaster;
    },
    fgSecurity(state) {
        return state.fgSecurity;
    },
    fgConfiguracoes(state) {
        return state.fgConfiguracoes;
    },
    fgDashboardPagar(state) {
        return state.fgDashboardPagar;
    },
    fgDashboardReceber(state) {
        return state.fgDashboardReceber;
    },
    fgFiltroAbas(state) {
        return state.fgFiltroAbas;
    },
    fgDataFiltroTipo(state) {
        return state.fgDataFiltroTipo;
    },
    fgEmitente(state) {
        return state.fgEmitente;
    },
    fgEmitenteDescricao(state) {
        return state.fgEmitenteDescricao;
    },
    fgOrdenacaoFiltroTipo(state) {
        return state.fgOrdenacaoFiltroTipo;
    }
};

const actions = {
    [UPDATE_DATA_INICIO](context, fgDataInicio) {
        context.commit(SET_DATA_INICIO, fgDataInicio);
        window.localStorage.setItem("dataInicio", fgDataInicio);
        window.localStorage.setItem(
            "validadeFiltroData",
            moment().format("YYYY-MM-DD")
        );
    },
    [UPDATE_DATA_FIM](context, fgDataFim) {
        context.commit(SET_DATA_FIM, fgDataFim);
        window.localStorage.setItem("dataFim", fgDataFim);
        window.localStorage.setItem(
            "validadeFiltroData",
            moment().format("YYYY-MM-DD")
        );
    },
    [UPDATE_EMPRESA](context, fgEmpresa) {
        context.commit(SET_EMPRESA, fgEmpresa);
        window.localStorage.setItem("empresa", fgEmpresa);
        window.localStorage.setItem(
            "validadeFiltroEmpresa",
            moment().format("YYYY-MM-DD")
        );
    },
    [UPDATE_PROJETO](context, fgProjeto) {
        context.commit(SET_PROJETO, fgProjeto);
    },
    [UPDATE_PLANO_FINANCEIRO](context, fgPlanoFinanceiro) {
        context.commit(SET_PLANO_FINANCEIRO, fgPlanoFinanceiro);
    },
    [UPDATE_CENTRO_DE_RESPONSABILIDADE](context, fgCentroDeResponsabilidade) {
        context.commit(SET_CENTRO_DE_RESPONSABILIDADE, fgCentroDeResponsabilidade);
    },
    [UPDATE_PORTADOR](context, fgPortador) {
        context.commit(SET_PORTADOR, fgPortador);
    },
    [UPDATE_MODO_PR](context, fgModoPR) {
        context.commit(SET_MODO_PR, fgModoPR);
        window.localStorage.setItem("modoPR", fgModoPR);
        window.localStorage.setItem(
            "validadeFiltroModoPR",
            moment().format("YYYY-MM-DD")
        );
    },
    [UPDATE_LOADING](context, fgLoading) {
        context.commit(SET_LOADING, fgLoading);
    },
    [UPDATE_LOADING_6MESES](context, fgLoading6meses) {
        context.commit(SET_LOADING_6MESES, fgLoading6meses);
    },
    [UPDATE_LOADING_6MESES](context, fgLoading6meses) {
        context.commit(SET_LOADING_6MESES, fgLoading6meses);
    },
    [UPDATE_PERM_MASTER](context, fgMaster) {
        context.commit(SET_PERM_MASTER, fgMaster);
    },
    [UPDATE_PERM_SECURITY](context, fgSecurity) {
        context.commit(SET_PERM_SECURITY, fgSecurity);
    },
    [UPDATE_PERM_CONFIGURACOES](context, fgConfiguracoes) {
        context.commit(SET_PERM_CONFIGURACOES, fgConfiguracoes);
    },
    [UPDATE_PERM_DASHBOARD_PAGAR](context, fgDashboardPagar) {
        context.commit(SET_PERM_DASHBOARD_PAGAR, fgDashboardPagar);
    },
    [UPDATE_PERM_DASHBOARD_RECEBER](context, fgDashboardReceber) {
        context.commit(SET_PERM_DASHBOARD_RECEBER, fgDashboardReceber);
    },
    [UPDATE_FILTRO_ABAS](context, fgFiltroAbas) {
        context.commit(SET_FILTRO_ABAS, fgFiltroAbas);
    },
    [UPDATE_DATA_FILTRO_TIPO](context, fgDataFiltroTipo) {
        context.commit(SET_DATA_FILTRO_TIPO, fgDataFiltroTipo);
        window.localStorage.setItem("dataFiltroTipo", fgDataFiltroTipo);
        window.localStorage.setItem("validadeDataFiltroTipo", moment().format("YYYY-MM-DD"));
    },
    [UPDATE_EMITENTE](context, fgEmitente) {
        context.commit(SET_EMITENTE, fgEmitente);
        window.localStorage.setItem("emitente", fgEmitente);
        window.localStorage.setItem("validadeEmitente", moment().format("YYYY-MM-DD"));
    },
    [UPDATE_EMITENTE_DESCRICAO](context, fgEmitenteDescricao) {
        context.commit(SET_EMITENTE_DESCRICAO, fgEmitenteDescricao);
        window.localStorage.setItem("emitenteDescricao", fgEmitenteDescricao);
        window.localStorage.setItem("validadeEmitenteDescricao", moment().format("YYYY-MM-DD"));
    },
    [UPDATE_ORDENACAO_FILTRO_TIPO](context, fgOrdenacaoFiltroTipo) {
        context.commit(SET_ORDENACAO_FILTRO_TIPO, fgOrdenacaoFiltroTipo);
        window.localStorage.setItem("ordenacaoFiltroTipo", fgOrdenacaoFiltroTipo);
        window.localStorage.setItem("validadeOrdenacaoFiltroTipo", moment().format("YYYY-MM-DD"));
    }
};

const mutations = {
    [SET_DATA_INICIO](state, fgDataInicio) {
        state.fgDataInicio = fgDataInicio;
    },
    [SET_DATA_FIM](state, fgDataFim) {
        state.fgDataFim = fgDataFim;
    },
    [SET_EMPRESA](state, fgEmpresa) {
        state.fgEmpresa = fgEmpresa;
    },
    [SET_PROJETO](state, fgProjeto) {
        state.fgProjeto = fgProjeto;
    },
    [SET_PLANO_FINANCEIRO](state, fgPlanoFinanceiro) {
        state.fgPlanoFinanceiro = fgPlanoFinanceiro;
    },
    [SET_CENTRO_DE_RESPONSABILIDADE](state, fgCentroDeResponsabilidade) {
        state.fgCentroDeResponsabilidade = fgCentroDeResponsabilidade;
    },
    [SET_PORTADOR](state, fgPortador) {
        state.fgPortador = fgPortador;
    },
    [SET_MODO_PR](state, fgModoPR) {
        state.fgModoPR = fgModoPR;
    },
    [SET_LOADING](state, fgLoading) {
        state.fgLoading = fgLoading;
    },
    [SET_LOADING_6MESES](state, fgLoading6meses) {
        state.fgLoading6meses = fgLoading6meses;
    },
    [SET_PERM_MASTER](state, fgMaster) {
        state.fgMaster = fgMaster;
    },
    [SET_PERM_SECURITY](state, fgSecurity) {
        state.fgSecurity = fgSecurity;
    },
    [SET_PERM_CONFIGURACOES](state, fgConfiguracoes) {
        state.fgConfiguracoes = fgConfiguracoes;
    },
    [SET_PERM_DASHBOARD_PAGAR](state, fgDashboardPagar) {
        state.fgDashboardPagar = fgDashboardPagar;
    },
    [SET_PERM_DASHBOARD_RECEBER](state, fgDashboardReceber) {
        state.fgDashboardReceber = fgDashboardReceber;
    },
    [SET_FILTRO_ABAS](state, fgFiltroAbas) {
        state.fgFiltroAbas = fgFiltroAbas;
    },
    [SET_DATA_FILTRO_TIPO](state, fgDataFiltroTipo) {
        state.fgDataFiltroTipo = fgDataFiltroTipo;
    },
    [SET_EMITENTE](state, fgEmitente) {
        state.fgEmitente = fgEmitente;
    },
    [SET_EMITENTE_DESCRICAO](state, fgEmitenteDescricao) {
        state.fgEmitenteDescricao = fgEmitenteDescricao;
    },
    [SET_ORDENACAO_FILTRO_TIPO](state, fgOrdenacaoFiltroTipo) {
        state.fgOrdenacaoFiltroTipo = fgOrdenacaoFiltroTipo;
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};